import { OperatorFunction, pipe } from 'rxjs';
import { map, mapTo, switchMap } from 'rxjs/operators';

import { Dependencies } from '../../../store';
import { calendarEventFromScheduleItemTransformer } from '../models/schedule.model';
import { ScheduleService } from '../services/schedule.service';

import { ChainGroup } from './calendar.epic';

export function retrieveEvents<TPayload>(
    deps: Dependencies,
    grp: ChainGroup<TPayload>,
    performerId: number,
): OperatorFunction<any, ChainGroup<TPayload>> {
    const service = deps.injector.get<ScheduleService>(ScheduleService);
    return pipe(
        switchMap(() =>
            service.getScheduleByUser(performerId, grp.startDate, grp.endDate),
        ),
        map((events) => {
            grp.events = events;
            grp.calendarEvents = grp.events.map(
                calendarEventFromScheduleItemTransformer,
            );
        }),
        mapTo(grp),
    );
}
